import { type SurveyQuestionType } from '../../../../models/Survey'
import { type ISurveySection, type IOption, type ISurveyItem } from '../../../../models/SurveyTemplate'

export enum Answers {
  UNANSWERED = 'unanswered',
  ANY = 'ANY'
}

export enum BranchingOperation {
  IS = 'is',
  IS_EMPTY = 'unanswered',
  IS_NOT_EMPTY = 'answered'
}

export interface SectionMap {
  sectionId: string
  items: SectionItem[]
  parentSectionId?: string
  origin?: Pick<SectionOrigin, 'itemId'>
  step: number | null
}

export interface SectionOrigin {
  itemId: string
  operation: BranchingOperation
  type: SurveyQuestionType
}

export interface SectionBranch {
  branchingValue: string | Answers
  sectionId: ISection['rawSurveySectionId']
  branchType: SurveyQuestionType
}

export interface SectionItem {
  itemId: string
  itemType: SurveyQuestionType
  value: string
  prompt: string
  object: string[] | IOption[] | null
  isRequired: boolean
  branches: SectionBranch[]
  revision: number
}

export interface ISection {
  surveySectionId: string
  rawSurveySectionId: string
  surveySectionRevision: NonNullable<ISurveySection['surveySectionRevision']>
  parentSurveySectionId: string | undefined
  rawParentSurveySectionId: string | undefined
  instructorId: string | undefined
  instructorName: string | null
  title: string | null
  descr: string | null
  surveyItems: SectionItem[]
  origin?: SectionOrigin
  children: ISection[]
  isSelectInstructorEnabled?: boolean
  isSurveyProjectAddedSection?: boolean
  name: string

}

export type HandleChangeFn = (value: string | string[], section: ISection['surveySectionId'], itemId: string, name?: string) => void
export type HandleBackFn = () => void
export type HandleNextFn = () => void
export type ShouldRenderSectionFn = (root: ISection, section: ISection) => boolean
export type RenderedSectionsRef = React.MutableRefObject<Map<string, boolean>>

export interface UseSurveyFeatureStepperReturnValue {
  sections: ISection[]
  renderedSectionsRef: RenderedSectionsRef
  // CR-213: full answer field names (itemId + modded section id) of invalid questions.
  invalidFieldNames: string[]
  handleChange: HandleChangeFn
  handleBack: HandleBackFn
  handleNext: HandleNextFn
  shouldRenderSection: ShouldRenderSectionFn
  triggerPulse: boolean
}

export interface SectionResponseItem {
  answer: string | string[]
  itemId: SectionItem['itemId']
  revision: SectionItem['revision']
  instructorId: ISection['instructorId']
  surveySectionId: ISection['surveySectionId']
  surveySectionRevision: ISection['surveySectionRevision']
}

export type OnSubmitFn = (responseItems: SectionResponseItem[]) => Promise<any>

// Interface for getItemsWithBranches function
export type GetItemsWithBranchesFn = (
  items: ISurveyItem[]
) => SectionItem[]
